import { type TranslationIDs, useIntl } from '@capsicum/common';
import { useCallback } from 'react';
import styled from 'styled-components';

export const useNCWExistingUsersTranslations = (href?: string) => {
	const { $t } = useIntl();

	const link = href ?? $t('agreement.tcLink');

	return useCallback(
		(translationID: TranslationIDs) =>
			$t<JSX.Element>(translationID, {
				blue: chunks => <S.Blue>{chunks}</S.Blue>,
				bold: chunks => <S.Bold>{chunks}</S.Bold>,
				br: <br />,
				link: chunks => (
					<S.Link href={link} rel="noreferrer" target="_blank">
						{chunks}
					</S.Link>
				),
				warning: chunks => <S.Warning>{chunks}</S.Warning>
			}),
		[href]
	);
};

namespace S {
	export const Link = styled.a`
		color: ${({ theme }) => theme.colors.text.brand.enabled};
	`;

	export const Bold = styled.span`
		font-weight: 700;
		${({ theme }) => theme.fonts.text.text1}
	`;

	export const Warning = styled.span`
		color: ${({ theme }) => theme.colors.text.warning.enabled};
	`;

	export const Blue = styled.span`
		color: ${({ theme }) => theme.colors.text.brand.enabled};
	`;
}
